module.exports = __webpack_public_path__ + "static/media/project6.74674592.png";